<ion-card>
    <ion-card-header>
        <ion-label>
            <h2>Patient Info</h2>
        </ion-label>
    </ion-card-header>
    <ion-card-content>
        <ion-input [(ngModel)]="document.patient.firstName" placeholder="Patient first name"></ion-input>
        <ion-input [(ngModel)]="document.patient.lastName" placeholder="Patient last name"></ion-input>
        <ion-input [(ngModel)]="document.patient.id" placeholder="Patient id"></ion-input>
    </ion-card-content>
</ion-card>
